import React from 'react';

export default class Page4 extends React.Component {

    render() {

        const {pageData} = this.props;

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">

                                            <table
                                                className="ilead_v_sport tablesrink para-bottompad ilead_v_sport_new_task"
                                                border="0" cellPadding="0" cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th className="green_curve " align="left" valign="top"
                                                        width="30%">Situation that needs resolving
                                                    </th>
                                                    <th align="left" valign="top" width="30%">Possible ways to
                                                        support
                                                    </th>
                                                    <th className=" green_curve1" align="left" valign="top"
                                                        width="30%&quot;">Possible ways to challenge
                                                    </th>
                                                </tr>

                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="30%"><p>A new intern is consistently failing to
                                                        meet deadlines</p>
                                                        <p>You are their line manager</p>
                                                    </td>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="30%"><p>Offer some coaching to improve his/her
                                                        efficiency</p>
                                                        <p>Ask for colleagues to hand down more reasonable
                                                            deadlines</p>
                                                    </td>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="30%"><p>Challenge the intern about whether they
                                                        are spending too much time on their phone/Facebook</p>
                                                        <p>Challenge their tendency to turn up late for work</p>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td className="darkgreen" align="left" valign="center"
                                                        width="30%">
                                                        <textarea rows="2"
                                                                  cols="2"
                                                                  name="1"
                                                                  id="1"
                                                                  value={pageData?.SituationThatNeedsResolving?.[1]}
                                                                  className="textareatandem textarea_peo"
                                                                  onChange={this.props.handleChangePageData('SituationThatNeedsResolving')}/>
                                                    </td>
                                                    <td className="darkgreen" align="left" valign="center"
                                                        width="30%">
                                                        <textarea rows="2"
                                                                  cols="2"
                                                                  name="1"
                                                                  id="1"
                                                                  value={pageData?.PossibleWaysToSupport?.[1]}
                                                                  className="textareatandem textarea_peo"
                                                                  onChange={this.props.handleChangePageData('PossibleWaysToSupport')}/>
                                                    </td>
                                                    <td className="darkgreen" align="left" valign="center"
                                                        width="30%">
                                                        <textarea rows="2"
                                                                  cols="2"
                                                                  name="1"
                                                                  id="1"
                                                                  value={pageData?.PossibleWaysToChallenge?.[1]}
                                                                  className="textareatandem textarea_peo"
                                                                  onChange={this.props.handleChangePageData('PossibleWaysToChallenge')}/>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td className="darkgreen" align="left" valign="center"
                                                        width="30%">
                                                        <textarea rows="2"
                                                                  cols="2"
                                                                  name="2"
                                                                  id="2"
                                                                  value={pageData?.SituationThatNeedsResolving?.[2]}
                                                                  className="textareatandem textarea_peo"
                                                                  onChange={this.props.handleChangePageData('SituationThatNeedsResolving')}/>
                                                    </td>
                                                    <td className="darkgreen" align="left" valign="center"
                                                        width="30%">
                                                        <textarea rows="2"
                                                                  cols="2"
                                                                  name="2"
                                                                  id="2"
                                                                  value={pageData?.PossibleWaysToSupport?.[2]}
                                                                  className="textareatandem textarea_peo"
                                                                  onChange={this.props.handleChangePageData('PossibleWaysToSupport')}/>
                                                    </td>
                                                    <td className="darkgreen" align="left" valign="center"
                                                        width="30%">
                                                        <textarea rows="2"
                                                                  cols="2"
                                                                  name="2"
                                                                  id="2"
                                                                  value={pageData?.PossibleWaysToChallenge?.[2]}
                                                                  className="textareatandem textarea_peo"
                                                                  onChange={this.props.handleChangePageData('PossibleWaysToChallenge')}/>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td className="darkgreen" align="left" valign="center"
                                                        width="30%">
                                                        <textarea rows="2"
                                                                  cols="2"
                                                                  name="3"
                                                                  id="3"
                                                                  value={pageData?.SituationThatNeedsResolving?.[3]}
                                                                  className="textareatandem textarea_peo"
                                                                  onChange={this.props.handleChangePageData('SituationThatNeedsResolving')}/>
                                                    </td>
                                                    <td className="darkgreen" align="left" valign="center"
                                                        width="30%">
                                                        <textarea rows="2"
                                                                  cols="2"
                                                                  name="3"
                                                                  id="3"
                                                                  value={pageData?.PossibleWaysToSupport?.[3]}
                                                                  className="textareatandem textarea_peo"
                                                                  onChange={this.props.handleChangePageData('PossibleWaysToSupport')}/>
                                                    </td>
                                                    <td className="darkgreen" align="left" valign="center"
                                                        width="30%">
                                                        <textarea rows="2"
                                                                  cols="2"
                                                                  name="3"
                                                                  id="3"
                                                                  value={pageData?.PossibleWaysToChallenge?.[3]}
                                                                  className="textareatandem textarea_peo"
                                                                  onChange={this.props.handleChangePageData('PossibleWaysToChallenge')}/>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td className="darkgreen" align="left" valign="center"
                                                        width="30%">
                                                        <textarea rows="2"
                                                                  cols="2"
                                                                  name="4"
                                                                  id="4"
                                                                  value={pageData?.SituationThatNeedsResolving?.[4]}
                                                                  className="textareatandem textarea_peo"
                                                                  onChange={this.props.handleChangePageData('SituationThatNeedsResolving')}/>
                                                    </td>
                                                    <td className="darkgreen" align="left" valign="center"
                                                        width="30%">
                                                        <textarea rows="2"
                                                                  cols="2"
                                                                  name="4"
                                                                  id="4"
                                                                  value={pageData?.PossibleWaysToSupport?.[4]}
                                                                  className="textareatandem textarea_peo"
                                                                  onChange={this.props.handleChangePageData('PossibleWaysToSupport')}/>
                                                    </td>
                                                    <td className="darkgreen" align="left" valign="center"
                                                        width="30%">
                                                        <textarea rows="2"
                                                                  cols="2"
                                                                  name="4"
                                                                  id="4"
                                                                  value={pageData?.PossibleWaysToChallenge?.[4]}
                                                                  className="textareatandem textarea_peo"
                                                                  onChange={this.props.handleChangePageData('PossibleWaysToChallenge')}/>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td className="darkgreen" align="left" valign="center"
                                                        width="30%">
                                                        <textarea rows="2"
                                                                  cols="2"
                                                                  name="5"
                                                                  id="5"
                                                                  value={pageData?.SituationThatNeedsResolving?.[5]}
                                                                  className="textareatandem textarea_peo"
                                                                  onChange={this.props.handleChangePageData('SituationThatNeedsResolving')}/>
                                                    </td>
                                                    <td className="darkgreen" align="left" valign="center"
                                                        width="30%">
                                                        <textarea rows="2"
                                                                  cols="2"
                                                                  name="5"
                                                                  id="5"
                                                                  value={pageData?.PossibleWaysToSupport?.[5]}
                                                                  className="textareatandem textarea_peo"
                                                                  onChange={this.props.handleChangePageData('PossibleWaysToSupport')}/>
                                                    </td>
                                                    <td className="darkgreen" align="left" valign="center"
                                                        width="30%">
                                                        <textarea rows="2"
                                                                  cols="2"
                                                                  name="5"
                                                                  id="5"
                                                                  value={pageData?.PossibleWaysToChallenge?.[5]}
                                                                  className="textareatandem textarea_peo"
                                                                  onChange={this.props.handleChangePageData('PossibleWaysToChallenge')}/>
                                                    </td>
                                                </tr>


                                                </tbody>
                                            </table>

                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">GETTING THE BALANCE RIGHT</span>
                                            </div>
                                            <div className="border_subtitle">So, how do you challenge and
                                                support at the same time?
                                            </div>
                                            <p>There are a number of factors which are vital to achieving this
                                                most difficult of balancing acts:</p>
                                            <div className="lightgreencontentbg keyquestionpad">
                                                <ul className="greenbullet-list">
                                                    <li><span
                                                        className="subtiltereg">Acknowledge the person</span>
                                                        <br/>
                                                        When considering what someone is telling or asking
                                                        you, it is important to show recognition of the
                                                        points they are making or the situation they
                                                        describe.
                                                    </li>
                                                    <li><span className="subtiltereg">Ask and listen</span> <br/>Entering
                                                        into a dialogue by asking questions and listening to
                                                        replies helps to build knowledge and gain an
                                                        understanding of the situation.
                                                    </li>
                                                    <li className="textbottompadding"><span
                                                        className="subtiltereg">Describe the situation</span>
                                                        <br/>It is often useful to outline the situation to
                                                        somebody or ask them to elaborate on their
                                                        perspective. This helps build a picture of what is
                                                        happening in order to gauge the right amount of
                                                        support or challenge required.
                                                    </li>

                                                </ul>
                                            </div>
                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.savePageData('Page5')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    }
}